import { LoadboardLabel, LoadboardValue } from "@/components/dataPages/loadboard";
import { getNumberWithCommas } from "@/utils/text";
import { TranslatedText } from "@/components/common/text";

export const LoadboardCargoInfo = ({ load }) => {
    return (
        <div className="h-[144px] w-full bg-cm-p-surface rounded-lg grid grid-cols-2 p-4 grid-rows-2">
            <div className="flex flex-col gap-1 justify-center">
                <LoadboardLabel text="Distance" />
                <LoadboardValue>
                    {load.loadDistance ? (
                        <>
                            {getNumberWithCommas(load.loadDistance, true)} <TranslatedText text="miles" />
                        </>
                    ) : (
                        " - "
                    )}
                </LoadboardValue>
            </div>
            <div className="flex flex-col gap-1 justify-center">
                <LoadboardLabel text="Commodity" />
                <LoadboardValue>{load.transportedCommodity || "-"}</LoadboardValue>
            </div>
            <div className="flex flex-col gap-1 justify-center">
                <LoadboardLabel text="Required equipments" />
                <LoadboardValue>{load.humanReadableEquipment || "-"}</LoadboardValue>
            </div>
            <div className="flex flex-col gap-1 justify-center">
                <LoadboardLabel text="Load weight" />
                <LoadboardValue>{load.loadWeight ? getNumberWithCommas(load.loadWeight, true) : "-"} lbs</LoadboardValue>
            </div>
        </div>
    );
};
